import {
    // FILE_UPLOAD,
    CREATE_ADMIN_CUSTOM_FORM_VERSION_HISTORY,
    RETRIEVE_ADMIN_CUSTOM_FORM_VERSION_HISTORY,
    // RETRIEVE_ARCHITECTURECOMPANYCONVERTEDLEADS,
    // RETRIEVE_ARCHITECTURECOMPANYPENDINGLEADS,
    RETRIEVESINGLE_ADMIN_CUSTOM_FORM_VERSION_HISTORY,
    UPDATE_ADMIN_CUSTOM_FORM_VERSION_HISTORY,
    DELETE_ADMIN_CUSTOM_FORM_VERSION_HISTORY,
    // RETRIEVE_ARCHITECTURESERVERSTAFF,
    // RETRIEVE_ARCHITECTURESERVERSERVICEUSERS,
} from "./type";
import AdminCustomFormVersionHistory from "../service/AdminCustomFormVersionHistory";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await AdminCustomFormVersionHistory.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await AdminCustomFormVersionHistory.create(data);
        dispatch({
            type: CREATE_ADMIN_CUSTOM_FORM_VERSION_HISTORY,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await AdminCustomFormVersionHistory.fetchList(data);
        dispatch({
            type: RETRIEVE_ADMIN_CUSTOM_FORM_VERSION_HISTORY,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await AdminCustomFormVersionHistory.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_ADMIN_CUSTOM_FORM_VERSION_HISTORY,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await AdminCustomFormVersionHistory.update(data);
        dispatch({
            type: UPDATE_ADMIN_CUSTOM_FORM_VERSION_HISTORY,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await AdminCustomFormVersionHistory.changeStatus(data);
//         dispatch({
//             type: UPDATE_ADMIN_CUSTOM_FORM_VERSION_HISTORY,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await AdminCustomFormVersionHistory.trash(data);
        dispatch({
            type: DELETE_ADMIN_CUSTOM_FORM_VERSION_HISTORY,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};